export default __webpack_public_path__ + "static/media/black.a61b171e.svg";